// extracted by css-extract-rspack-plugin
export default {"clearButton":"EzpiODDVMQ8UWyuC","icon":"uS0NhuW1bScPD5cv"};